import { useState } from "preact/hooks";
import { useLocation } from "preact-iso";
import { signIn } from "../lib/store";
import { Head } from "../components/Head";

export function SignIn() {
  const [key, setKey] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const { route } = useLocation();

  async function go(e?: Event) {
    e?.preventDefault();
    if (!key || busy) return;
    setBusy(true);
    const problem = await signIn(key);
    setBusy(false);
    if (problem) { setErr(problem); return; }
    setKey("");
    route("/");
  }

  return (
    <main class="screen signal">
      <Head right="Sign in" />
      <form class="stack" style="margin-top: var(--space-6)" onSubmit={go}>
        <span class="say">Paste your Musette key from your password manager.</span>
        <span class="soft">This device stays signed in for a year.</span>
        <input type="text" name="username" autocomplete="username" value="musette" readOnly hidden />
        <div class="composer">
          <input id="key" name="password" type="password" autocomplete="current-password" spellcheck={false} placeholder="Your key" aria-label="Your Musette key"
            value={key} onInput={(e) => { setKey((e.target as HTMLInputElement).value); setErr(null); }} />
        </div>
        {err && <span class="soft" role="alert">{err}</span>}
        <button type="submit" class="pill wide" disabled={!key || busy}>{busy ? "Signing in" : "Sign this device in"}</button>
      </form>
    </main>
  );
}
